import { RATE_STALE_AFTER_DAYS } from '@familywallet/shared';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useCurrentRates } from '../lib/ledger';
import { buttonVariants } from './ui/button';

/**
 * Warns when a family rate is missing or older than 7 days. People who may manage rates get an
 * "Update rate" button to the Rates screen.
 */
export function StaleRateNotice({ showLink = true }: { showLink?: boolean }) {
  const { t } = useTranslation();
  const rates = useCurrentRates();
  const stale = (rates.data?.items ?? []).filter((i) => i.stale);
  if (!rates.data || stale.length === 0) return null;
  return (
    <div
      role="note"
      className="flex flex-col gap-2 rounded-xl border border-line bg-surface-2 p-3 text-sm text-fg"
    >
      {stale.map((i) => (
        <p key={i.quoteCurrency}>
          {i.current
            ? t('rates.staleWarning', {
                quote: i.quoteCurrency,
                days: RATE_STALE_AFTER_DAYS,
              })
            : t('rates.noRateWarning', { quote: i.quoteCurrency })}
        </p>
      ))}
      {showLink && rates.data.canManage && (
        <Link to="/family/rates" className={buttonVariants({ variant: 'secondary' })}>
          {t('rates.update')}
        </Link>
      )}
    </div>
  );
}
